export default __webpack_public_path__ + "static/media/headshot.94bfa80c.jpeg";